import React from "react";
import { Form, Input, Select, InputNumber, Switch } from "antd";
import { IconStar } from "@tabler/icons-react";

export default function BasicSection({
  issuerOptions = [],
  categoryOptions = [],
}) {
  return (
    <>
      <Form.Item
        label="Банк (Issuer)"
        name="issuerId"
        rules={[{ required: true, message: "Банк сонгоно уу" }]}
      >
        <Select
          options={issuerOptions}
          placeholder="Банк сонгох"
          showSearch
          filterOption={(input, opt) =>
            opt.label.toLowerCase().includes(input.toLowerCase())
          }
          allowClear
        />
      </Form.Item>

      <Form.Item
        label="Ангилал"
        name="categoryId"
        rules={[{ required: true, message: "Ангилал сонгоно уу" }]}
      >
        <Select
          options={categoryOptions}
          placeholder="Ангилал сонгох"
          showSearch
          filterOption={(input, opt) =>
            opt.label.toLowerCase().includes(input.toLowerCase())
          }
          allowClear
        />
      </Form.Item>

      <Form.Item
        label="Картын нэр"
        name="name"
        rules={[{ required: true, message: "Нэр оруулна уу" }]}
      >
        <Input placeholder="Жишээ: Khan Gold Card" allowClear />
      </Form.Item>

      <Form.Item
        label="Тайлбар нэршил"
        name="highlight"
        rules={[{ required: true, message: "Тайлбар нэршил өгнө үү" }]}
      >
        <Input placeholder="Онцлох мэдээлэл" />
      </Form.Item>

      <Form.Item
        label="Үнэлгээ (rating)"
        name="rating"
        rules={[{ required: true, message: "Үнэлгээ өгнө үү" }]}
      >
        <InputNumber
          prefix={<IconStar size={16} color="#e68200ff" />}
          min={0}
          max={5}
          step={0.1}
          placeholder="4.5"
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item label="Захиалах холбоос" name="applyUrl">
        <Input placeholder="https://..." />
      </Form.Item>
      <Form.Item
        name="featured"
        label="Нүүрэнд онцлох"
        valuePropName="checked"
        tooltip="Нүүр хуудасны 'Жишээ бүтээгдэхүүн' хэсэгт харагдана"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </>
  );
}
